export default {

    // EMPLSALARY 
    employeeid: { displayName: 'Employee ID', description: 'Unique identifier for each employee' },
    fdate: { displayName: 'From Date', description: 'Start date of the period' },
    tdate: { displayName: 'To Date', description: 'End date of the period' },
    comments: { displayName: 'Comments', description: 'Additional comments' },
    description: { displayName: 'Description', description: 'Description of the item' },
    salaryschemeid: { displayName: 'Salary Scheme ID', description: 'Identifier for the salary scheme' },
    currency: { displayName: 'Currency', description: 'Currency in which the salary is paid' },
    annualGrossSalary: { displayName: 'Annual Gross Salary', description: 'Total annual salary before deductions' },
    monthlyGrossSalary: { displayName: 'Monthly Gross Salary', description: 'Total monthly salary before deductions' },


    //TRAINING
    duration: { displayName: 'Duration', description: 'Duration of the event' },
    organisation: { displayName: 'Organisation', description: 'Name of the organisation' },
    fees: { displayName: 'Fees', description: 'Fees associated with the event' },
    subsidy: { displayName: 'Subsidy', description: 'Subsidy provided' },
    hrs: { displayName: 'Hours', description: 'Number of hours' },
    title: { displayName: 'Title', description: 'Title of the event' },
    dot: { displayName: 'Date of Training', description: 'Date when the training occurs' },
    comments: { displayName: 'Comments', description: 'Additional comments' },
    company: { displayName: 'Company Code', description: 'Name of the company' },
    enddate: { displayName: 'End Date', description: 'End date of the event' },
    workhrs: { displayName: 'Work Hours', description: 'Number of work hours' },
    costperempl: { displayName: 'Cost per Employee', description: 'Cost per employee' },
    isabroad: { displayName: 'Is Abroad', description: 'Indicates if the event is abroad' },
    topic: { displayName: 'Topic', description: 'Topic of the event' },
    subject: { displayName: 'Subject', description: 'Subject of the event' },
    ismulticompany: { displayName: 'Is Multi-Company', description: 'Indicates if multiple companies are involved' },
    othercosts: { displayName: 'Other Costs', description: 'Other associated costs' },
    isinternal: { displayName: 'Is Internal', description: 'Indicates if the event is internal' },
    iseLearning: { displayName: 'Is eLearning', description: 'Indicates if the event is eLearning' },
    doCertExp: { displayName: 'Certificate Expiry', description: 'Indicates if the certificate expires' },
    certExpNotify: { displayName: 'Certificate Expiry Notification', description: 'Notification for certificate expiry' },
    equalCost: { displayName: 'Equal Cost', description: 'Equal cost distribution' },
    trainingLocation: { displayName: 'Training Location', description: 'Location of the training' },
    externalFacilitator: { displayName: 'External Facilitator', description: 'External facilitator involved' },
    subsidyApplies: { displayName: 'Subsidy Applies', description: 'Indicates if subsidy applies' },
    subsidyProvider: { displayName: 'Subsidy Provider', description: 'Provider of the subsidy' },
    doSubsidyAppl: { displayName: 'Subsidy Application', description: 'Indicates if subsidy application is done' },
    doSubsidyReceived: { displayName: 'Subsidy Received', description: 'Indicates if subsidy is received' },
    userEditable: { displayName: 'User Editable', description: 'Indicates if the field is user editable' },
    CODE: { displayName: 'Code', description: 'Code associated with the event' },
    isCompleted: { displayName: 'Is Completed', description: 'Indicates if the event is completed' },
    methodCode: { displayName: 'Method Code', description: 'Code for the method used' },

    //BRANCH
    branch: { displayName: 'Branch Code', description: 'The name of the branch' },
    description: { displayName: 'Description', description: 'A brief description' },
    addr1: { displayName: 'Address Line 1', description: 'The first line of the address' },
    addr2: { displayName: 'Address Line 2', description: 'The second line of the address' },
    addr3: { displayName: 'Zip code', description: 'Zip code' },
    tel: { displayName: 'Telephone Number', description: 'The contact telephone number' },
    acCode: { displayName: 'Account Code', description: 'The primary account code' },
    acCode1: { displayName: 'Secondary Account Code', description: 'The secondary account code' },
    branchDME: { displayName: 'Branch DME Code', description: 'The DME code for the branch' },
    d365Code: { displayName: 'D365 Code', description: 'The D365 system code' },


    // Data types
    real: {displayName: 'Decimal'},
    nvarchar: {displayName: 'Text'},
    nvarchar: {displayName: 'Text'},
    smalldatetime: {displayName: 'Date'},
    bit: {displayName: '0/1'},
    uniqueidentifier: {displayName: 'Unique Identifier'},
    decimal: {displayName: 'Decimal'},
    smallint: {displayName: 'Number (Up to 65,535)'},
};
